import React, {Suspense, useCallback, useRef, memo, useState, useEffect, useLayoutEffect} from 'react'
import _ from '/home/ps/root'
import { Ref, promise, Blank, session, initialGeoCode, equal, copy, cache} from '../../global'
import Field from './part/field'
import Album from './part/album'
import Header from './header'
import More from './view/more'
import Row from './row'
import Loading from './view/loading'
// import { usePark } from '../../hook/park'
import {go, tcp, tcp2, dispatch, newRow} from '../../io'
const __DEV__ = import.meta.env.__DEV__
const ID = 'table'
let _table_ = 0
Ref[ID] = {}
const _Table_ = Ref[ID]
const Table = prop => {
  const { param, vendorname, connected, uid, vid, verb, views, lang, master, cookie, login, owner, u, route, vendor } = prop.master
  const { db, v, park } = prop
  const store = { ...park[v]?.[db] }
  const rows = { ...store.default }
  const storeConfig = u=='store' && v=='config'
  // const pub0 = store[`0${_.PUB}`]
  const _pks = route.length > 2 && !isNaN(route[2]) ? [route[2]] : Object.keys(rows).reduce((acc, pk, i) => {
// if (v=='item' && prop.pks) debugger
  // const pk = Number(_pk)
if (isNaN(pk)) debugger
// if (acc.length>10)debugger
    if (_.MASTER_.includes(u)) return acc
    if (acc.includes(pk)) return acc
    if (pk < 0) return acc
    // if (!pub0.includes(pk)) return acc
    acc.push(pk)
    // if (!(pk < 0) && !acc.includes(pk)) acc.push(pk)
    return acc
  }, [])
  // const pks = _.LOGIN_[u] ? [uid] : ((collapse ? [] : prop.pks) || _pks)
  // const _collapse = prop.collapse===true ? prop.collapse : (prop.ID=='state' ? !((storeConfig || u==v || _.MASTER_.includes(v)) && !prop.pks) : (prop.row ? true : false))
  const _collapse = prop.collapse || (
    prop.ID=='state' ? !((storeConfig || u==v || _.MASTER_.includes(v)) && !prop.pks) : (prop.row ? true : false)
  )
  // const collapsePks = _collapse ? [] : (prop.pks.length==0 ? prop.pks : _pks)
  // const pks = _.MASTER_.includes(u) ? [uid] : (collapsePks.length ? collapsePks : _pks)
  // const pks = _.MASTER_.includes(u) ? [uid] : (_collapse ? [] : (prop.pks?.length ? prop.pks : _pks))
// if (pks.length) debugger
// if (collapsePks) debugger
// if (u=='item') debugger
// if (prop.control  && prop.ID=='state' && v=='item' && _collapse) debugger
// if (prop.row && prop.control) debugger
// if (u!=v && v=='item')debugger
  const [ table, _setTable ] = useState({
    ...prop.table,
    _id_: _table_++,
    // key: `${ db } ${ v } ${ verb }${ prop.pks?.length || _pks.length ? ' ' : '' }${ prop.pks?.length ? prop.pks.join(' ') : _pks.join(' ') }`,
    key: `${ db } ${ v } ${ verb } ${ prop.pks?.length ? prop.pks.join(' ') : '[]' }`,
    storeConfig,
    collapse: _collapse, //: prop.collapse===true ? prop.collapse : (prop.ID=='state' ? !((storeConfig || u==v || _.MASTER_.includes(v)) && !prop.pks) : (prop.row ? true : false)),
    // init: prop.row ? false : prop.ID!='state',
    init: false,
    more: false,
    album: _.FILE_[0],
    // fetching: false,
    _toggle: 0,
  })
  const { _toggle, collapse, init, more, album, fetching } = table
  const setTable = nextState => _setTable(prevState => typeof nextState == 'function' ? nextState(prevState) : ({...prevState, init: true, ...nextState}))
  const setAlbum = album => setTable({album, init})
  // const pks = _.MASTER_.includes(u) ? [uid] : (collapse ? [] : (prop.row ? (prop.pks?.length ? prop.pks : _pks) : _pks))
  // const a = _pks.length>0
  const pks = _.MASTER_.includes(u) ? (login ? [uid] : []) : (prop.row ? prop.pks : _pks)
// if (v=='item' && a) debugger
  // useEffect(() => {
  // // if (pks.length)debugger
  //   pks.length && setTable({key: `${ table.key } ${ pks.join(' ') }`})
  // }, [pks.length])
if (u=='item' && !collapse && !pks?.length) debugger
  const toggle = () => {
    setTable({_toggle: !_toggle})
    if (prop.toggle) prop.toggle()
  }
// if (v=='config' && pks.length) debugger
  const count = prop.pks ? prop.pks.length : park[v]?.[db]?.[_.PUB]
  let title = v=='purchase' && connected || storeConfig ? false : (prop.title || (_.MASTER_.includes(v) ? true : master[v] && master[v].i))
  const content = [__DEV__ && `${ID} ${v}`]
  const file = `https://${cookie.p}.${_.DOMAIN}/usr/pub/img/table.jpg`
  const tableClick = (_db, _v, _pk, _collapse=!collapse, _init=init) => {
    if (!_.Q_.includes(v) || db<0 || (u==v && !prop.row)) return
    if (!_init) {
      const buffer = {[v]: {}}
      if (!(park[v]?.default)) buffer[v].default = 'find'
      if (prop.pks) {
        prop.pks.reduce((acc, pk, i) => {
          if (i>_.LIMIT-1) return acc
          if (!(park[v]?.[db]?.default?.[pk])) {
            if (!buffer[v][db]) buffer[v][db] = {default: {}}
            buffer[v][db].default[pk] = 'find'
          }
          return acc
        }, {})
      } else if (!(park[v]?.[db]?.[`0${_.PUB}`])) buffer[v][db]={default: []}
      if (Object.keys(buffer[v]).length) {
        console.log({tableClick: ID, buffer})
        // setTable({fetching: true})
        tcp2({request: {ID, _id_: table._id_, lang, buffer: {[vendor.home]: buffer}},
          callback: arg => {
            console.log({ID, arg})
            promise(({ park, p}) => {
              const fid = _.JSON_[prop.body?.id]
              console.log({[ID]: 'callback', db, fid})
              const parked = Object.keys(buffer).reduce((vs, v) => {
                if (!Object.keys(buffer[v]).reduce((dbs, db) => {
                  if (!Object.keys(buffer[v][db]).reduce((verbs, verb) => {
                    if (!Object.keys(buffer[v][db][verb]).reduce((pks, pk) => {
                      if (_.SQL_.includes(verb) && !park[v][db][verb][pk]) return false
                      return pks
                    }, true)) return false
                    return verbs
                  }, true)) return false
                  return dbs
                }, true)) return false
                return vs
              }, true)
              if (!parked) return true
              // setTable({fetching: false})
              if (prop.rowUpdate) prop.rowUpdate('callback')
              // toggle()
            }) // promise
          }, // callback:
        }) // tcp2
      }
    } // if (!init)
    // setTable({collapse: _collapse, init: true, fetching: true})
    setTable({collapse: _collapse, init: true})
  } // tableClick
  useEffect(() => {
    _Table_[table.key] = { tableClick, setTable, table }
    return () => delete(_Table_[table.key])
  })
  if (_Table_[table.key]) _Table_[table.key][v] = { album }
  const desc = prop.p.ref || false
  if (u=='store' && _.STORE_.includes(v) && store[_.PUB]==0) return null
  const propHeader = {...prop, park, table, before: [], onClick: tableClick, file, title, count, desc, storeConfig, print: true}
  if (v=='media') propHeader.before.push(<Album {...prop} setAlbum={setAlbum} key={Album.ID}/>)
  content.push(
    <Header
      { ...propHeader }
      key = { `${ table.key } header` }
    />
  )
  if (!park[v]?.[verb]) {
    if (_.MASTER_.includes(u)) return <Suspense fallback={<Loading/>}/>
    return content
  }
  const _db = v=='purchase' ? vid : db
  let pk = prop.pks ? false : Blank[_db]?.[v]
  if (!(prop.ID=='state' && _.NO_NEW_.includes(v))) { // not side panels and system tables
    if (!prop.row && prop.pk===true) { // not reviews and items (from inside row)
      if (v=='login') {
        if (!login) pk = Blank[_db]?.[v]==uid ? uid : newRow(prop, _db, v)
      } else pk = Blank[_db]?.[v] || newRow(prop, _db, v)
    }
  }
  const sell = _.SELL_.includes(v) || false
  const style = { margin: '10px' }
// if (prop.new[_db]) debugger
// if (((v!='purchase' && u==v) || (v=='purchase' && vid!=uid) || v=='notice' || v=='follow' || _.MASTER_.includes(v)) && pk<0 && park[v]?.[_db]?.default?.[pk] && prop.new[_db]) debugger
  content.push(
    <section
      _id_ = { table._id_ }
      key = { table.key }
      className = { `${ ID } collapse ${ collapse ? '' : 'expand' }` }
    >
      {__DEV__ && u==v && <div>{ID} v={v} negative pk={pk} </div>}
      {
        ((v!='purchase' && u==v) || (v=='purchase' && vid!=uid) || v=='notice' || v=='follow' || _.MASTER_.includes(v)) && pk<0 && park[v]?.[_db]?.default?.[pk] && prop.new[_db] &&
          <Row { ...prop }
            db = { _db }
            toggle = { toggle }
            table = { { ...table, pk, sell } }
          />
      }
      {
        prop.control
      }
      {
        pks.reduce((acc, pk, i) => {
          if (prop.control && prop.scroll != i) return acc
          if (v=='purchase' && connected) return acc
          const row = park[v]?.[db]?.default?.[pk] || cache(`${lang}${db}${v}${pk}`)
          if (u=='media' && album != row.album) return acc
// if (row=='find') debugger
          if (row && row != 'find') acc.push(
            <Row {...prop}
              key = { `${ table.key } ${ pk }` }
              table = { { ...table, pk, sell } }
              setTable = { setTable }
              toggle = { toggle }
            />
          )
          return acc
        }, [])// ? (__DEV__ && prop.control && <div> debug table render empty pks { pks.join(', ') } </div>) : ''
      }
      {
        (v=='item' || v=='review') ? '' :
        <More
          { ...prop }
          table = { { ...table, sell } }
          more = { prop.pks || [] }
          value = { prop.value || [] }
          setTable = { setTable }
        />
      }
      {
        window.opener && _.Q_.includes(u) ? (
          <div className='center'>
            <span style={{margin: '0 auto'}}>
              <input
              type ='button'
              className ='theme'
              value = {master.select.i}
              style = {style}
              onClick = { e => {
                e.stopPropagation()
                e.preventDefault()
                prop.message()
                window.close()
              }}/>
              <input
              type ='button'
              className ='theme'
              value = {master.cancel.i}
              style = {style}
              onClick = { e => {
                e.stopPropagation()
                e.preventDefault()
                // setTimout(()=>
                window.close()
                // , 1)
              }}/>
            </span>
          </div>
        ) : ''
      }
      {
        window.opener && param.cart && prop.master.cartCount[vid] ? (
          <div className='center'>
            <span style={{margin: '0 auto'}}>
              <input
              type='button'
              className='theme'
              value={`Deliver ${prop.master.cartCount[vid]} item`}
              style={style}
              onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                const v = 'purchase'
                const npk = prop.new[vid][v]
                const cart = park[v][vid].default[npk]
                const m = param.m
                prop.message({cart, m})
                window.close()
              }}/>
            </span>
          </div>
        ) : ''
      }
    </section>
  )
  // if (window.opener && param.cart) debugger
  // if (window.opener) debugger
  // if (param.cart) debugger
  // console.log({Ref})
  return content
}
Table.ID = ID
export default Table
